import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { VitalCardBeneficiariesModal } from './VitalCardBeneficiariesModal.component'

const withUnmountHoc = withUnmountTransition(VitalCardBeneficiariesModal)
export { withUnmountHoc as VitalCardBeneficiariesModal }
